<template>
  <v-app id="app">
    <div class="text-center">
      <v-bottom-sheet v-model="snackbar" :timeout="-1" vertical>
        <v-sheet class="primary">
          <v-row justify="center" align="center">
            <v-col cols="12" md="6">
              <div class="pa-5">
                <p class="fondo--text">
                  Utilizamos cookies propias y de terceros y el almacenamiento
                  web del navegador para mejorar la experiencia del usuario a
                  través de su navegación. Si continúas navegando aceptas su
                  uso.
                </p>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div class="d-flex justify-center pa-5 pa-md-0">
                <v-btn rounded outlined color="white" class="mx-2" @click="snackbar = false">
                  <router-link to="Coockies" class="white--text px-5"
                    >Más información</router-link
                  >
                </v-btn>
                <v-btn
                  color="primary"
                  rounded
                  text
                  v-bind="attrs"
                  @click="snackbar = false"
                  class="white px-5 mx-2"
                >
                  Aceptar
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-sheet>
      </v-bottom-sheet>
    </div>
    <navigation
    />
    <v-main class="pt-0">
      <router-view></router-view>
    </v-main>
    <v-scale-transition>
      <v-btn
        fab
        v-show="fab"
        v-scroll="onScroll"
        dark
        fixed
        bottom
        right
        color="secondary"
        @click="toTop"
      >
        <v-icon>mdi-arrow-up</v-icon>
      </v-btn>
    </v-scale-transition>
    <foot />
  </v-app>
</template>

<script>
import navigation from "./components/Navigation.vue";
import foot from "./components/Foot.vue";

export default {
  name: "App",

  components: {
    navigation,
    foot,
  },

  data: () => ({
    fab: null,
    snackbar: true,
  }),


  methods: {
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 60;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
};
</script>

<style>

#app {
  overflow-x: hidden
}

@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@600&display=swap');

h3, h2, h1 {
  font-family: 'Quicksand', sans-serif;
}

#container {
  max-width: 1440px;
}

.v-main {

  background-attachment: fixed;
  background-position: center;
  background-size: cover;
  background-color: #fbfbfb;
}

.before-enter.anim {
  opacity: 0;
  transform: translateY(50px);
  transition: all 1.5s ease-in-out;
}
.enter.anim {
  opacity: 1;
  transform: translateY(0px);
}

.hr {
  border-top: 3px solid;
  width: 8vw;
}

.before-enter.hr {
  opacity: 0;
  transition: all 1.5s ease-in-out;
}

.enter.hr {
  opacity: 1;
}

</style>